import { parseISO, format, formatDistanceToNow } from 'date-fns';
import { Link } from 'react-router-dom';
import Loading from '../../components/common/loading';
import ReactPaginate from 'react-paginate';
import React from 'react';

function parseQuery(queryString) {
  const query = {};
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}

const activityIcons = {
  user_edited: { icon: 'manage_accounts', url: '/users/logged-in' },
  pat_created: { icon: 'key', url: '' },
  pat_deleted: { icon: 'delete', url: '' },
  guest_user_created: { icon: 'group_add', url: '' },
  guest_user_modified: { icon: 'edit', url: '' },
  guest_user_deleted: { icon: 'delete', url: '' },

  device_paired: { icon: 'login', url: '/devices/connected/:resourceId' },
  device_unpaired: { icon: 'logout', url: '/devices/connected/:resourceId' },
  device_disconnected: { icon: 'cloud_off', url: '/devices/connected/:resourceId' },
  device_connected: { icon: 'cloud_done', url: '/devices/connected/:resourceId' },
  device_edited: { icon: 'edit', url: '/devices/connected/:resourceId' },
  device_firmware_updated: { icon: 'update', url: '/devices/connected/:resourceId' },

  outlet_switched: { icon: "outlet", url: "/devices/connected/:enclosureSn/outlets/:resourceId", },
  outlet_edited: { icon: "edit", url: "/devices/connected/:enclosureSn/outlets/:resourceId", },
  device_fw_update: { icon: 'update', url: '/devices/connected/:resourceId' },

  event_triggered: { icon: 'notification', url: '' },
  event_created: { icon: 'event_upcoming', url: '' },
  event_edited: { icon: 'edit_calendar', url: '' },

  group_created: { icon: 'ballot', url: '' },
  group_edited: { icon: 'edit', url: '' },
  group_deleted: { icon: 'delete', url: '' },
};

export default class ActivityLog extends React.Component {
  state = {
    activityFilter: '',
    searchText: '',
    dark: document.body.classList.contains('dark-mode'),
  };

  componentDidMount() {
    const params = parseQuery(window.location.search);
    if (params.action) {
      this.setState({ activityFilter: params.action });
      this.props.onFilter && this.props.onFilter(params.action);
    }
    this.darkObserver = new MutationObserver(() => {
      this.setState({ dark: document.body.classList.contains('dark-mode') });
    });
    this.darkObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  componentWillUnmount() {
    this.darkObserver && this.darkObserver.disconnect();
  }

  render() {
    const {
      activity = [],
      refresh,
      title,
      loading,
      searchActivity,
      meta = {},
      page = 1,
      onPageChange,
      onFilter,
    } = this.props;

    const { dark } = this.state;
    return (
      <div
        style={{
          // backgroundColor: dark ? '#424242' : '#fff',
          color: dark ? '#f3f3f3' : '#333',
          // border: `1px solid ${dark ? '#666' : '#ddd'}`,
          // borderRadius: '4px',
          padding: '15px',
          paddingBottom: '2rem',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {title && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingBottom: '1rem',
            }}
          >
            <span
              style={{
                fontWeight: '600',
                fontSize: '110%',
              }}
            >
              {title}
            </span>
          </div>
        )}
        <div>

            {searchActivity && (
              <div
                style={{
                  // paddingLeft: '10px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <input
                  type="text"
                  placeholder="Search by serial number or name"
                  value={this.state.searchText}
                  onChange={(e) => this.setState({ searchText: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      searchActivity(this.state.searchText);
                    }
                  }}
                  style={{  width: "420px" }}
                />
                {/* <button className="button" onClick={() => searchActivity(this.state.searchText)}>
                  <i className="material-icons" style={{ fontSize: '20px', verticalAlign: 'middle' }}>
                    search
                  </i>
                </button> */}
                <span
                  className="search-icon-button"
                  style={{ margin: "0 0 1rem" }}
                  onClick={() => searchActivity(this.state.searchText)}
                >
                  <i className="material-icons">search</i>
                </span>
              </div>
            )}
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingBottom: '1rem',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
            }}
          >
            <div
              style={{
                // paddingLeft: '10px',
              }}
            >
              {/* <span
                style={{
                  fontSize: '85%',
                  color: '#666',
                }}
              >
                Filter by activity
              </span> */}
              <select
                onChange={(e) => {
                  const val = e.target.value;
                  this.setState({ activityFilter: val });
                  onFilter && onFilter(val);
                }}
                value={this.state.activityFilter}
                style={{}}
              >
                <option value="">Filter by Activity</option>
                <option value="device_paired,device_unpaired">Device Pairing Activity</option>
                <option value="device_disconnected,device_connected">Device Connection Activity</option>
                <option value="device_edited">Device Editing Activity</option>
                <option value="outlet_switched,outlet_edited">Outlet Switching/Editing Activity</option>
                <option value="device_fw_update">Device Firmware Update Activity</option>
                {!this.props.selectedDevice && (
                  <option value="group_created,group_edited,group_deleted">Outlet Group Activity</option>
                )}
              </select>
            </div>
          </div>
          {loading ? (
            <div>
              <Loading black />
            </div>
          ) : (
            <div>
              {refresh && (
                <span onClick={() => refresh()} style={{ cursor: 'pointer' }}>
                  <i className="material-icons" style={{ fontSize: '30px' }}>
                    refresh
                  </i>
                </span>
              )}
            </div>
          )}
        </div>

        <div style={{ overflowY: 'auto', flex: 1 }}>
          {activity.length > 0 ? (
            <div>
              {activity.map((history) => {
                const timestamp = parseISO(history.createdAt);
                return (
                  <div key={history.createdAt}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <span>
                        <i
                          className="material-icons"
                          style={{ fontSize: '150%', color: dark ? '#f3f3f3' : '#1d262f' }}
                        >
                          {activityIcons[history.action]
                            ? activityIcons[history.action].icon
                            : 'edit'}
                        </i>
                      </span>
                      <div>
                        <div>
                          {history.description}
                          {console.log(history)}
                          {activityIcons[history.action] && activityIcons[history.action].url ? (
                            <>
                              <span style={{ paddingRight: '3px' }}>:</span>
                              <span style={{ textDecoration: 'underline' }}>
                                <Link
                                  to={activityIcons[history.action].url.replace(
                                    ':resourceId',
                                    history.resourceId
                                  ).replace(':enclosureSn', history.enclosureSn)}
                                >
                                  {history.resourceName}
                                </Link>
                              </span>
                            </>
                          ) : (
                            `: ${history.resourceName}`
                          )}
                          {!history.details && history.counter > 1 &&
                            ` ${history.counter} times within 5 minutes`}
                        </div>
                        <div>
                          <div style={{ color: dark ? '#ccc' : '#777', fontSize: '91%' }}>
                            {format(timestamp, 'MMM d, HH:mm ')} -
                            {` ${formatDistanceToNow(timestamp)} ago`}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        borderLeft: `solid ${dark ? '#555' : '#ddd'} 2px`,
                        minHeight: '30px',
                        marginLeft: '10px',
                        marginTop: '10px',
                        marginBottom: '10px',
                        paddingLeft: '20px',
                        paddingTop: '10px',
                        paddingBottom: '10px',
                      }}
                    >
                      {history.details && (
                        <div
                          style={{
                            backgroundColor: dark ? '#333' : 'rgb(236 239 243)',
                            padding: '15px',
                            border: `solid ${dark ? '#555' : '#ccc'} 1px`,
                            borderRadius: '3px',
                            fontSize: '90%',
                          }}
                        >
                          {history.details}{' '}
                          {history.counter > 1 &&
                            `${history.counter} times within 5 minutes`}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
              {meta.totalPages > 1 && onPageChange && (
                <ReactPaginate
                  pageCount={meta.totalPages || 1}
                  forcePage={(page || 1) - 1}
                  onPageChange={({ selected }) => onPageChange(selected + 1)}
                  pageClassName="page-item"
                  previousLabel="Previous"
                  nextLabel="Next"
                  containerClassName="react-paginate"
                  activeClassName="selected"
                />
              )}
            </div>
          ) : loading ? (
            <Loading black />
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              No Activity Yet
            </div>
          )}
        </div>
      </div>
    );
  }
}

